import React, { useState } from 'react';
import CusPageCardContainer from '../../../components/shared/CusPageCardContainer';
import CusLabelSelect from '../../../components/material-ui/CusLabelSelect';
import { useAppSelector } from '../../../store';
import { Stack } from '@mui/material';
import BalanceCrypto from '../../../components/finance/BalanceCrypto';
import { useSessionStorage } from 'usehooks-ts';

export default function BalanceGateway() {
  const casinos = useAppSelector((state) => state.user.info.casino) || [];
  const casinoOptions = casinos.map((el) => ({ label: el.casinoName || el.botName, value: el.id }));

  const [selectCasino, setSelectCasino] = useSessionStorage(
    'balanceGatewaySelectCasino',
    casinoOptions[0]?.value
  );

  return (
    <CusPageCardContainer title="Crypto gateway balance">
      <Stack gap={2}>
        <CusLabelSelect
          label={'Select casino'}
          value={selectCasino}
          options={casinoOptions}
          onChange={setSelectCasino}
        />

        <BalanceCrypto key={'BalanceGateway_' + selectCasino} casinoId={selectCasino} />
      </Stack>
    </CusPageCardContainer>
  );
}
